const FIXED_FACE = 'fixed'
const ADJUSTABLE_FACE = 'adjustable'

const getMatrizTypes = (matriz) => {
    const types = matriz.get('type')
    if (!types || !types.length) return null
    return types
}

const kitDescriptionMatchesFace = (kit, face) => {
    const description = (kit.get('description_component') || '').toLowerCase()
    if (face === FIXED_FACE) {
        return description.includes('fix') || description.includes('shaft')
    }
    return description.includes('regul')
}

const matrizHasKitsMatchingFaceByDescription = (matriz, face, relationKeys) => {
    const kits = relationKeys
        .flatMap(key => matriz.get(key) || [])
        .filter(Boolean)

    return kits.some(kit => kitDescriptionMatchesFace(kit, face))
}

const matrizSupportsAlizFace = (matriz, face, relationKeys) => {
    const types = getMatrizTypes(matriz)

    if (types) {
        if (face === FIXED_FACE) return types.some(type => String(type).startsWith('fixed'))
        return types.some(type => String(type).startsWith('adjustable'))
    }

    return matrizHasKitsMatchingFaceByDescription(matriz, face, relationKeys)
}

const matrizHasRelationKits = (matriz, relationKeys) => {
    return relationKeys.some(key => (matriz.get(key) || []).length)
}

export const getAlizSectionValues = (alizMatriz, face, relationKeys) => {
    const sections = (alizMatriz || [])
        .filter(matriz => (
            matrizHasRelationKits(matriz, relationKeys) &&
            matrizSupportsAlizFace(matriz, face, relationKeys)
        ))
        .map(matriz => matriz.get('section'))
        .flat()

    return [...new Set(sections)]
        .map(el => parseInt(el))
        .filter(el => el <= 100)
        .sort((a, b) => a - b)
}

export const hasAlizPanelOptions = (alizMatriz, face, relationKeys) => {
    return (alizMatriz || []).some(matriz => (
        matrizHasRelationKits(matriz, relationKeys) &&
        matrizSupportsAlizFace(matriz, face, relationKeys)
    ))
}

export const ALIZ_RELATION_KEYS = {
    alizar: ['component_kit', 'component_kit_fusion_frame'],
    band: ['component_kit_with_band', 'component_kit_with_band_fusion_frame'],
    panel: ['component_kit_with_panel', 'component_kit_with_panel_fusion_frame'],
}

export const resolveAlizComponentMatch = (rawMatch) => {
    if (!rawMatch) return { componentId: null, finishingId: null }
    if (String(rawMatch).includes('__')) {
        const [componentId, finishingId] = String(rawMatch).split('__')
        return { componentId: componentId || null, finishingId: finishingId || null }
    }
    return { componentId: rawMatch, finishingId: null }
}

export { FIXED_FACE, ADJUSTABLE_FACE }
